import { environment } from "src/environments/environment";

export abstract class HttpService {

    private _url: string = environment.api

    constructor(complement: string) {
        this._url = `${this._url}/${complement}`
    }

    protected get url(): string {
        return this._url
    }

    implementQueries(filter): string {
        let queryArray = []
        for (const key in filter) {
            if (filter[key]) {
                queryArray.push(`${key}=${filter[key]}`)
            }
        }
        const query = queryArray.join('&')
        return `?${query}`
    }
}